import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'profile.sociallinks.social.links': {
    id: 'profile.sociallinks.social.links',
    defaultMessage: 'Social Links',
    description: 'A section of a user profile',
  },
});

export default messages;
